import { useQuery } from '@tanstack/react-query';
import { useWishlist } from '~/features/commerce-api/hooks/wishlist/useWishList';

export const useFavoriteProducts = () => {
    const { items, getProductList } = useWishlist();
    const itemIds = items.map((item) => item.productId);

    return useQuery({
        queryKey: ['favorites', itemIds],
        queryFn: getProductList,
        staleTime: 0,
        refetchOnWindowFocus: false,
        // Don't fetch if there are no items
        enabled: items?.length > 0,
    });
};
